import { useState } from 'react'
import { useCookies } from 'react-cookie'

import { useAppSelector } from 'app-redux/hooks'
import { useMobileControlToggles } from 'hooks/useMobileControlToggles.module'

import { CardType } from 'types/deck'
import { SubComponentProps } from 'components/elements/FloatingToolbar/types'

import QuickAddCard from 'components/cardSearchPanel/searchFormElements/quickAddCard'
import { SimpleButton } from 'components/formElements/Button'

import { getPriceStringAndUrl } from 'utils/Price'
import { onQuickAddCard } from '../FilterBar'

import styles from './mobileQuickAdd.module.scss'

const MobileQuickAdd = ({ onClose }: SubComponentProps) => {
  const [mobileLayoutControls, setMobileLayoutControls] = useMobileControlToggles()
  const [{ keepMobileQuickAddOpen }, setCookies] = useCookies(['keepMobileQuickAddOpen'])

  const [results, setResults] = useState(new Array<CardType>())

  const [lastAddedId, setLastAddedId] = useState<string | undefined>(undefined)

  const priceSource = useAppSelector(state => state.active.priceSource)
  const quickAddOptions = useAppSelector(state => state.cacheables.quickAddOptions)

  const handleAddCard = (card: CardType) => {
    return onQuickAddCard(card).then(() => {
      if (quickAddOptions.dontClearOnSelect) return

      if (`${keepMobileQuickAddOpen}` === 'true') {
        // THIS IS A HACK - changes the key of the quick add component to reset it
        setLastAddedId(card.id)
        setResults([])

        return
      }

      // Close drawer
      if (onClose) onClose()
    })
  }

  return (
    <div className={styles.container}>
      <QuickAddCard
        focusOnMount
        menuClassName={styles.none}
        onCardSelected={handleAddCard}
        onResultsChanged={(_: boolean, cards: CardType[]) => setResults(cards)}
        key={lastAddedId}
      />

      {!results.length && (
        <div className={styles.options}>
          <SimpleButton
            icon={`${keepMobileQuickAddOpen}` === 'true' ? 'check square' : 'square outline'}
            onClick={() => {
              setCookies('keepMobileQuickAddOpen', `${keepMobileQuickAddOpen}` !== 'true', {
                path: '/',
                expires: new Date(Date.now() + 1000 * 60 * 60 * 24 * 40),
              })
            }}>
            Keep drawer open after selection
          </SimpleButton>
          <SimpleButton
            icon={mobileLayoutControls.quickAdd ? 'check square' : 'square outline'}
            onClick={() => setMobileLayoutControls({ quickAdd: !mobileLayoutControls.quickAdd })}>
            Pin Quick add above deck
          </SimpleButton>
        </div>
      )}

      <div className={styles.results}>
        {results.map(card => (
          <button key={card.id} onClick={() => handleAddCard(card)}>
            <span className={styles.name}>{card.name}</span>

            <span className={styles.extras}>
              <span className={styles.set}>
                ({card.setCode}) ({card.collectorNumber})
              </span>

              <span className={styles.price}>
                {getPriceStringAndUrl(card, priceSource[0], card.modifier !== 'Normal').price}
              </span>
            </span>
          </button>
        ))}
      </div>
    </div>
  )
}

export default MobileQuickAdd
